import { useState } from "react";

const initials = (name = "") => name.split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
const fmtDate = (iso) => new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Jakarta" });

export function ReviewsCard({ reviews = [] }) {
  const [shown, setShown] = useState(4);
  return (
    <section className="ib-card" data-testid="talent-reviews-card">
      <h2 className="ib-title">Ulasan</h2>
      {reviews.length === 0 && <p className="mt-4 text-[#626262]" data-testid="reviews-empty">Belum ada ulasan untuk talent ini.</p>}
      <div className="mt-6 divide-y divide-[#E5E7EB]">
        {reviews.slice(0, shown).map((r, i) => (
          <article key={i} className="py-6 first:pt-0 last:pb-0" data-testid="talent-review">
            <div className="flex items-start gap-4">
              <span className="w-16 h-16 rounded-full bg-[#053B5D] text-white flex items-center justify-center text-xl font-medium shrink-0">{initials(r.nickname)}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-3 flex-wrap">
                  <div>
                    <p className="font-semibold text-black">{r.nickname}</p>
                    <p className="text-[#626262] text-sm">{r.service_name} | <span className="font-semibold text-black">{r.score >= 4 ? "Terbantu 😊" : "Kurang terbantu"}</span></p>
                  </div>
                  <time className="text-sm text-[#626262]">{fmtDate(r.at)}</time>
                </div>
                {r.comment && <p className="mt-3 text-[#626262] leading-6">{r.comment}</p>}
              </div>
            </div>
          </article>
        ))}
      </div>
      {reviews.length > shown && (
        <div className="mt-6 text-center"><button onClick={() => setShown((n) => n + 4)} className="ib-outline rounded-full px-6 font-medium" data-testid="reviews-show-more">Tampilkan Lebih Banyak</button></div>
      )}
    </section>
  );
}
